var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-xl":"","fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('trip-control',{attrs:{"page":"bill"}}),_c('trip-view',{attrs:{"page":"bill"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }